import 'bootstrap/scss/bootstrap.scss';

import './application.scss';
import './welcome.scss';